import { useState, useEffect } from "react";

/**
 * Returns true when the given CSS media query matches.
 * Uses MediaQueryList.addEventListener("change") instead of window resize,
 * so it only re-renders when the breakpoint is actually crossed.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => {
    if (typeof window === "undefined") return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    const media = window.matchMedia(query);
    setMatches(media.matches);
    const listener = (e: MediaQueryListEvent) => setMatches(e.matches);
    media.addEventListener("change", listener);
    return () => media.removeEventListener("change", listener);
  }, [query]);

  return matches;
}
